import { SVGProps } from 'react'

export const ProfileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.3334 14C13.3334 13.0696 13.3334 12.6044 13.2185 12.2259C12.96 11.3736 12.293 10.7067 11.4408 10.4482C11.0623 10.3333 10.5971 10.3333 9.66668 10.3333H6.33336C5.40298 10.3333 4.93779 10.3333 4.55926 10.4482C3.70699 10.7067 3.04005 11.3736 2.78151 12.2259C2.66669 12.6044 2.66669 13.0696 2.66669 14M11 5C11 6.65685 9.65687 8 8.00002 8C6.34317 8 5.00002 6.65685 5.00002 5C5.00002 3.34315 6.34317 2 8.00002 2C9.65687 2 11 3.34315 11 5Z"
      stroke="#344054"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
